import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Navbar from './common/Navbar';
import Footer from './common/Footer';
import Breadcrumb from './common/Breadcrumb';
import ProductCard from './common/ProductCard';
import { useCart } from '../context/CartContext';

const Wishlist = () => {
  const navigate = useNavigate();
  const { wishlistItems } = useCart();


  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#faf8f5' }}>
      <Navbar />

      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Breadcrumb items={[{ label: 'Wishlist' }]} />

        <Typography variant="h4" fontWeight="bold" color="#3E2723" sx={{ mb: 3 }}>
          My Wishlist
          {wishlistItems.length > 0 && (
            <Typography component="span" color="text.secondary" sx={{ ml: 1, fontSize: '1rem' }}>
              ({wishlistItems.length} {wishlistItems.length === 1 ? 'item' : 'items'})
            </Typography>
          )}
        </Typography>

        {wishlistItems.length > 0 ? (
          <Grid container spacing={3}>
            {wishlistItems.map((product) => (
              <Grid
                item
                xs={6}
                sm={6}
                md={3}
                key={product._id}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <ProductCard product={product} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Paper
            elevation={0}
            sx={{
              p: 6,
              borderRadius: 3,
              bgcolor: '#fff',
              textAlign: 'center',
            }}
          >
            <FavoriteIcon sx={{ fontSize: 80, color: '#ddd', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Your wishlist is empty
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              Save items you love by clicking the heart icon
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/filter/All')}
              sx={{
                bgcolor: '#8B4513',
                '&:hover': { bgcolor: '#6d3610' },
                px: 4,
              }}
            >
              Explore Products
            </Button>
          </Paper>
        )}
      </Container>

      <Footer />
    </Box>
  );
};

export default Wishlist;
